import useNavigationDrawer from '@Guidelines/Shell/AppShell/Hooks/useNavigationDrawer';
import { NAVIGATION_DRAWER_ID } from '@Guidelines/Shell/AppShell/Menu/NavigationMenu/Mobile/NavigationDrawer';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import { Menu } from 'lucide-react';
import type * as React from 'react';

const buttonStyle = css`
	display: none;
	align-items: center;
	justify-content: center;
	width: 2.5rem;
	height: 2.5rem;
	flex-shrink: 0;
	padding: 0;
	border: none;
	border-radius: ${theme.radii.pill};
	background-color: transparent;
	color: ${theme.colors.ink};
	cursor: pointer;
	transition:
		background-color ${theme.motion.duration},
		color ${theme.motion.duration};

	&:hover {
		background-color: ${theme.colors.surfaceMuted};
	}

	&:focus-visible {
		outline: 2px solid ${theme.colors.accent};
		outline-offset: 2px;
	}

	@media (max-width: ${theme.layout.compactBreakpoint}) {
		display: inline-flex;
	}
`;

/** Opens the navigation drawer; only shown below `layout.compactBreakpoint`, where the menu column is gone. */
const MenuToggleButton: React.FC = () => {
	const { isOpen, open } = useNavigationDrawer();

	return (
		<button
			type="button"
			css={buttonStyle}
			onClick={open}
			aria-label="Ouvrir le menu"
			aria-expanded={isOpen}
			aria-controls={NAVIGATION_DRAWER_ID}
		>
			<Menu size={20} />
		</button>
	);
};

export default MenuToggleButton;
